import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39ad7f3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popup__title" }, "Privacy policy", -1))
const _hoisted_2 = ["innerHTML"]

import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { useDataStore } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupPrivacy',
  setup(__props) {

const dataStore = useDataStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", {
        class: "privacy",
        innerHTML: _unref(dataStore).privacyText
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})